// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__x_AWK","main":"about_main__zrovy"};